module.exports = __webpack_public_path__ + "f0f1a1e8f7ab537a7dd2512704807bce.png";